class ApiError extends Error {
  constructor(status, info) {
    super(`Api request failed with status: ${status}`);
    this.status = status;
    this.info = info;
    this.name = 'ApiError';
  }
}

export { ApiError };
//# sourceMappingURL=ApiError.js.map
